import { render, staticRenderFns } from "./NewEditProfessorPage.vue?vue&type=template&id=c1d2be82&scoped=true"
import script from "./NewEditProfessorPage.vue?vue&type=script&lang=js"
export * from "./NewEditProfessorPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditProfessorPage.vue?vue&type=style&index=0&id=c1d2be82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d2be82",
  null
  
)

export default component.exports